var React = require('react');

function ShareFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M22 0H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h11v-9h-3v-4h3V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763V11h4.44l-1 4h-3.44v9H22a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"}));
}

ShareFacebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ShareFacebook;

ShareFacebook.default = ShareFacebook;
